import React, { useEffect } from "react";
import "./Banner.css";
import bannerImg from "../../../Img/banner-thumb-1.jpg";
import { FaPlay } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

const Banner = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
      easing: "ease-in-out",
    });
  }, []);

  const handleScroll = (e) => {

    console.log('sddfdf');

    e.preventDefault();
    const targetElement = document.getElementById("project-id");
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="relative bg-[#0A0D1F] tp-banner-bg overflow-hidden ">
      {/* Text Content */}
      <div className="containers mx-auto px-4 lg:py-[32px] py-0 relative ">
        <div className="grid lg:mt-[60px] mt-0 ">
          <div className="grid-span-12 z-30">
            <div className="tp-banner ">
              {/* <span className="text-white text-sm uppercase tracking-widest mb-4 block tp-banner-sub-title " data-aos="fade-down">
                Solution is Just One Click Away
              </span> */}

              <h2 className=" tp-banner-title font-bold text-white leading-tight text_font_family  " data-aos="fade-up">
                <span className="text-blue-500"> Solution </span> Is Just <br />
                A Click Away
              </h2>

              <h5 className=" text-white text-[23px] text_baner_home " data-aos="fade-up">
                Your trusted partner in software development,<br /> UI/UX design, and AI-driven innovation
              </h5>

              <div data-aos="fade-up" className="mt-11">
                <Link to="/Contact" onClick={() => window.scrollTo(0, 0)} className="button_same  text-white py-[14px] px-[18px]  rounded-md font-semibold transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105">
                  Discover More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Shapes */}
      <div className="absolute inset-0 pointer-events-none">
        <div className=" tp-banner-shape-one">
          <img
            decoding="async"
            src="https://data.themeim.com/wp/tecz/wp-content/themes/tecz/assets/img/banner/one/banner-one-shape-1.png"
            alt="shape one"
            className="w-full h-auto"
          />
        </div>
        <div className=" tp-banner-shape-two hidden md:block">
          <img
            decoding="async"
            src="https://data.themeim.com/wp/tecz/wp-content/themes/tecz/assets/img/banner/one/banner-one-shape-2.png"
            alt="shape two"
            className="w-full h-auto"
          />
        </div>
      </div>

      <div className="tp-banner-video hidden md:block ">
        <a
          href="https://www.youtube.com/watch?v=TYYf8zYjP5k"
          target="_blank"
          rel="noopener noreferrer"
          className="popup-video flex justify-content-center rounded-full text-white transition duration-300"
        >
          <i className="flaticon-play "><FaPlay /></i>
        </a>
      </div>

      {/* Social Links (Left Side) */}
      {/* <div className=" hidden xl:block tp-banner-social ">
        <a
          href="https://www.facebook.com/people/Dynamics-Softlink/pfbid0g64aTq9gktqyQBpX9dmYgj37YmnGXusW8s8pAxXe1qxyvKLrR5fbteLgei29v1q6l/?mibextid=wwXIfr&rdid=ZDhRHTOw1Hg5oSJQ&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F16rVuK4knh%2F%3Fmibextid%3DwwXIfr"
          className="text-white tracking-widest hover:text-blue-400 transition duration-300"
        >
          FACEBOOK
        </a>
        <a
          href="#"
          className="text-white tracking-widest hover:text-sky-400 transition duration-300"
        >
          LINKEDIN
        </a>
        <a
          href="https://www.instagram.com/dynamicsoftlink?igsh=MXN4YjRxOHVlcGVuYw=="
          className="text-white tracking-widest hover:text-blue-400 transition duration-300"
        >
          INSTAGRAM
        </a>
      </div> */}

      {/* Scroll Down */}
      <div className="tp-banner-scroll-down absolute left-1/2 -translate-x-1/2">
        <div className="tp-banner-scroll-shape w-[238px] h-[70px]">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="238"
              height="70.594"
              viewBox="0 0 238 70.594"
            >
              <path
                d="M847,980s40.865-5.656,69-43,81.412-36.188,103,0,66,43,66,43H847Z"
                transform="translate(-847 -909.406)"
                fill="#fff"
                fillRule="evenodd"
              />
            </svg>
          </span>
        </div>
      </div>

      <div className="tp-banner-scroll-mouse text-center ">
        <a href="#project-id" className="inline-block " onClick={handleScroll}>
          <span>
            <svg
              id="scroll-down"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="26"
              viewBox="0 0 16 26"
            >
              <circle
                cx="8.5"
                cy="7.5"
                r="2"
                fill="none"
                stroke="#131023"
                className="cls-5"
                strokeWidth="1"
              />
              <path
                d="M963,922h5a5,5,0,0,1,5,5v15a5,5,0,0,1-5,5h-5a5,5,0,0,1-5-5V927A5,5,0,0,1,963,922Z"
                transform="translate(-957.5 -921.5)"
                fill="none"
                stroke="#131023"
                strokeWidth="1"
                fillRule="evenodd"
              />
            </svg>
          </span>
        </a>
        <p className="text-white text-sm mt-2">Scroll Down</p>
      </div>

      <div className="tp-banner-bg-shape" style={{ backgroundImage: `url(${bannerImg})` }}></div>
    </section>
  );

};

export default Banner;
